import { Pipe } from '@angular/core';
import { Proxy } from '../services/proxy/proxy.service';

@Pipe({
  name: 'PorNombrePipe'
})
export class PorNombrePipe {

  transform(value, args?) {
    let val: string = args;
    return value.filter((item: Proxy.PrPersonaAlineable) => {
      return (val.length == 0 || (item.apellido1.toLowerCase().indexOf(val.toLowerCase()) > -1) || (item.apellido2.toLowerCase().indexOf(val.toLowerCase()) > -1) || (item.nombre.toLowerCase().indexOf(val.toLowerCase()) > -1));
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/porNombre.ts